// POST /api/ui/trader-management/clients/unassign
// Manager odpina klienta od aktualnego handlowca (Client.traderId -> NULL).

import { axios } from 'api';
import { useMutation, useQueryClient, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IPostUnassignClientFromTraderRequest {
  clientId: number;
}

export interface IPostUnassignClientFromTraderResponse {
  status?: number;
  message?: string;
  data?: { clientId: number; previousTraderId: number };
}

const post = (
  payload: IPostUnassignClientFromTraderRequest,
): Promise<IPostUnassignClientFromTraderResponse> =>
  axios.post('/trader-management/clients/unassign', payload);

export const usePostUnassignClientFromTrader = (
  options?: UseMutationOptions<
    IPostUnassignClientFromTraderResponse,
    IError,
    IPostUnassignClientFromTraderRequest
  >,
) => {
  const queryClient = useQueryClient();
  return useMutation<
    IPostUnassignClientFromTraderResponse,
    IError,
    IPostUnassignClientFromTraderRequest
  >((payload) => post(payload), {
    ...options,
    onSuccess: async (data, vars, ctx) => {
      await queryClient.invalidateQueries(['trader-management-traders']);
      await queryClient.invalidateQueries(['trader-management-trader-summary']);
      await queryClient.invalidateQueries(['trader-management-unassigned-clients']);
      options?.onSuccess?.(data, vars, ctx);
    },
  });
};
